import { HiShieldCheck } from "react-icons/hi2";

export function SummaryRow({ label, value, bold, stacked = false }) {
  if (stacked) {
    return (
      <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-0.5 py-2 border-b border-gray-100 last:border-b-0">
        <span
          className={`text-xs shrink-0 ${bold ? "font-bold text-gray-900" : "text-gray-500"}`}
        >
          {label}
        </span>
        <span
          className={`text-xs break-all ${bold ? "font-bold text-gray-900" : "font-semibold text-gray-900"}`}
        >
          {value}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0">
      <span
        className={`text-xs ${bold ? "font-bold text-gray-900" : "text-gray-500"}`}
      >
        {label}
      </span>
      <span
        className={`text-xs sm:text-sm ${bold ? "font-bold text-gray-900" : "font-semibold text-gray-900"}`}
      >
        {value}
      </span>
    </div>
  );
}

export function ResultStatusIcon({ icon: Icon, bgClassName, iconClassName }) {
  return (
    <div
      className={`w-20 h-20 rounded-full flex items-center justify-center ${bgClassName}`}
    >
      <Icon size={44} className={iconClassName} />
    </div>
  );
}

export function TransactionDetailsCard({ children }) {
  return (
    <div className="w-full rounded-xl border border-gray-200 bg-gray-50 p-4">
      <p className="text-xs text-center font-semibold text-gray-500 uppercase tracking-wide mb-3">
        Transaction Details
      </p>
      {children}
    </div>
  );
}

export function FundsSafeMessage({ amount, balance, reversed = false }) {
  return (
    <div className="w-full space-y-1">
      <div className="flex items-center justify-center gap-2">
        <HiShieldCheck
          style={{ fontSize: 16 }}
          className="text-green-600 shrink-0"
        />
        <p className="text-sm font-semibold text-green-700">
          Your Funds are Safe.
        </p>
      </div>
      <p className="text-xs sm:text-sm text-gray-500 text-center">
        {reversed
          ? `${amount} has been reversed back to your wallet. Your wallet balance is ${balance}.`
          : `${amount} has not been deducted from your wallet. Your wallet balance remains ${balance}.`}
      </p>
    </div>
  );
}
